/* eslint-disable react-hooks/exhaustive-deps */
// ** React Imports
import { useRef, useState, useCallback, useEffect, useMemo } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'

// ** Icon Imports
import Icon from '../../../@core/components/icon'

// ** Utils Imports
import { Button, Grid, Pagination, TextField, Typography } from '@mui/material'

// import { ToastSuccess } from '../toast/ToastSuccess'
import { showSnackbar } from '../toast/snackbarService'
import { useTheme } from '@emotion/react'
import { useSmartClaim } from '../../../hooks/smartClaim'
import { copyToAutofill } from './copyToAutofill'

const ChatLog = props => {
  // ** Props
  const [generatedTickets, setGeneratedTickets] = useState(null)
  let { data, totalPage, handlePageChange, page, showPagination, downloadData, statusTab, type, selectedCompanyName, heading } = props
  const [disabledIndexes, setDisabledIndexes] = useState({});
  const [loaderIndexes, setLoaderIndexes] = useState({});
  // const [recordList, setRecordList] = useState(null)
  const [selectedCards, setSelectedCards] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [ticket, setTicket] = useState({})
  const theme = useTheme();
  const sc_claim = useSmartClaim();
  const inputRefs = useRef({})
  const inputValuesRef = useRef({}); // Store input values without causing re-renders

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCards([]); // Deselect all
    } else {
      setSelectedCards(
        data.map((record, index) => {
          let payload = {
            id: record.id,
            ticketId: ticket[index] || null,
            gstProfileId: record.gstProfileId,
            description: record.description,
          };

          // Dynamically add statusOfClaim if statusTab is "COMPLETED" or "PENDING"
          if (statusTab === "COMPLETED" || statusTab === "PENDING") {
            payload.statusOfClaim = "CLAIM_NOT_SUBMITTED";
          }

          return payload;
        })
      );

    }
    setSelectAll(!selectAll);
  };

  const handleBulkFail = async () => {
    if (selectedCards.length > 0) {
      // Convert callback-based API call into a Promise
      const submitClaim = (e) => {
        return new Promise((resolve) => {
          sc_claim.postClaimSubmit(e, (response) => {
            if (response.status === "success") {
              showSnackbar("Record Submitted successfully!", "success");
            } else {
              showSnackbar("Something Went Wrong", "error");
            }
            resolve(response); // Resolve the promise
          });
        });
      };

      try {
        // Wait for all API calls to complete
        await Promise.all(selectedCards.map(submitClaim));
      } catch (error) {
        showSnackbar("Something Went Wrong", "error");
      }
    } else {
      showSnackbar("Select Card to Fail", "error");
    }
  };

  useEffect(() => {
    setGeneratedTickets(null)
  }, [selectedCompanyName])

  const handleChange = (index, value) => {
    inputValuesRef.current[index] = value; // Update ref
    setTicket(prevState => ({
      ...prevState,
      [index]: value
    }));
  };
  const handleBlur = (index) => {
    setTicket(prevState => ({
      ...prevState,
      [index]: inputValuesRef.current[index] || ''
    }));
  };


  const copyToClipboard = useCallback((text, data, index, field) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        showSnackbar("Failed to copy. Please copy manually.", "error");
      }
      document.body.removeChild(textArea);
    }

    if (data) {
      downloadImages(data, index)
      // setDisabledIndexes((prev) => ({ ...prev, [index]: true })); // Disable the clicked button
    } else {
      showSnackbar(`${field} copied successfully!`, "success")
    }
  }, []);

  const downloadImages = useCallback((images, primaryIndex) => {
    if (!downloadData || downloadData.length === 0) return;

    let totalFiles = downloadData.filter(key => images[key]).length; // Count valid images
    let completedFiles = 0;

    if (totalFiles === 0) {
      setDisabledIndexes({});
      return; // Stop early if no valid files
    }

    setDisabledIndexes((prev) => ({ ...prev, [primaryIndex]: true })); // Start loader

    downloadData.forEach((key, index) => {
      if (!images[key]) {
        console.warn(`⚠️ Skipping download: No image found for key ${key}`);
        return;
      }

      fetch(images[key])
        .then(response => {
          console.log('response', response)
          if (!response.ok) {
            showSnackbar(response.statusText, "error");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          let link = document.createElement("a");
          let fileURL = window.URL.createObjectURL(blob);
          console.log('fileURL', fileURL)
          link.href = fileURL;

          let fileType = images[key].split("/").pop().split("?")[0].split(".")[1];
          let filename = `${key}-${images.subOrderNumber}.${fileType}`;
          link.download = filename;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Clean memory
          window.URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error("❌ Error downloading file:", error);
          showSnackbar("Failed To Download", "error");

        })
        .finally(() => {
          completedFiles++;
          if (completedFiles === totalFiles) {
            // ✅ Stop loader after all files are downloaded
            setTimeout(() => {
              showSnackbar("All files downloaded successfully!", "success");
              setDisabledIndexes({});
            }, 500);
          }
        });
    });
  }, [downloadData]);


  const handleSubmitRequest = (record, index) => {
    if (Object.entries(ticket).length === 0 || !ticket[index]) {
      showSnackbar("Ticket Id Required", "error");
    } else {
      setLoaderIndexes((prev) => ({ ...prev, [index]: true }));
      let payload = {
        id: record.id,
        ticketId: ticket[index],
        gstProfileId: record.gstProfileId,
        description: record.description,
      };
      if (statusTab === "PENDING") {
        payload["statusOfClaim"] = "COMPLETED";
      }
      if (statusTab === "CLAIM_NOT_SUBMITTED") {
        payload["statusOfClaim"] = "COMPLETED";
      }


      sc_claim.postClaimSubmit(payload, (response) => {
        if (response.status === "success") {
          setTicket(prevState => ({ ...prevState, [index]: '' }));
          inputRefs.current[index].value = '';
          inputValuesRef.current[index] = ''
          setGeneratedTickets((prev) => ({ ...prev, [index]: true }));

          showSnackbar("Record Submitted successfully!", "success");
        } else {
          showSnackbar("Something Went Wrong", "error");
        }
        setLoaderIndexes({});
      });
    }
  };

  const handleFailRequest = (record, index) => {
    setLoaderIndexes((prev) => ({ ...prev, [index]: true }));
    let payload = {
      id: record.id,
      gstProfileId: record.gstProfileId,
      description: record.description,
    };
    if (statusTab === "COMPLETED" || statusTab === "PENDING") {
      payload["statusOfClaim"] = "CLAIM_NOT_SUBMITTED";
    }

    sc_claim.postClaimSubmit(payload, (response) => {
      if (response.status === "success") {
        setGeneratedTickets((prev) => ({ ...prev, [index]: true }));
        showSnackbar("Record Submitted successfully!", "success");
      } else {
        showSnackbar("Something Went Wrong", "error");
      }
      setLoaderIndexes({});
    });

  }

  const formatDate = (isoString) => {
    const date = new Date(isoString);

    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "2-digit",
      year: "numeric",
    });
  };


  // ** Renders user chat
  const renderChats = () => {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Box className='chat-body' style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <Grid item xs={12}>
              {/* {recordList && recordList.length > 0 && recordList.map((order, index) => { */}
              {data && data.length > 0 && data.map((order, index) => {
                if ((generatedTickets && generatedTickets[index])) {
                  return ''
                } else {
                  return (
                    <Box key={index} display="flex" justifyContent="center" mb={2}>
                      {(generatedTickets && generatedTickets[index]) ?
                        ''
                        :
                        <>
                          <Box minHeight={120} bgcolor={generatedTickets && generatedTickets[index] ? theme.palette.grey[300] : "white"} borderRadius={2} width="100%" p={2} display="flex" justifyContent="space-between">
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
                                <Typography variant="body2" display='flex' alignItems='center' mb={0.3} sx={{
                                  fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                }}>
                                  Suborder Id: <strong style={{ letterSpacing: "0.5px", marginLeft: "2px", fontSize: "inherit" }}>{order.subOrderNumber}</strong>
                                  {disabledIndexes[index] ?
                                    <Box sx={{ marginLeft: "5px", background: theme.palette.grey[300], width: '25px', display: 'flex', justifyContent: 'center', alignItems: "center", height: '25px', borderRadius: '50%' }}>
                                      <Icon icon="svg-spinners:6-dots-scale" width="16" height="16" />
                                    </Box>
                                    :
                                    <>
                                      <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.subOrderNumber, '', index, "Suborder Id")} />
                                      <Box onClick={() => copyToClipboard(order.subOrderNumber, order, index, "Suborder Id")} sx={{ border: "2px solid rgb(0 169 75)", marginLeft: "5px", background: "#28c76f29", width: '25px', display: 'flex', justifyContent: 'center', alignItems: "center", height: '25px', borderRadius: '50%' }}>
                                        <Icon icon="material-symbols:download-rounded" width="18" height="18" style={{ color: 'rgb(0 169 75)' }} />
                                      </Box>
                                    </>
                                  }
                                </Typography>
                                {statusTab && statusTab !== 'COMPLETED' &&
                                  <Typography variant="body2" mb={0.4} sx={{
                                    fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                  }}>
                                    AWB No: <strong style={{ letterSpacing: "0.5px" }}>{order.meeshoOrder && order.meeshoOrder.awbNumber}</strong> {order.meeshoOrder && order.meeshoOrder.awbNumber ? <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.meeshoOrder.awbNumber, '', index, 'AWB No')} /> : ''}
                                  </Typography>
                                }
                                {statusTab && statusTab === 'COMPLETED' &&
                                  <Typography variant="body2" mb={0.4} sx={{
                                    fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                  }}>
                                    <span >AWB No: </span><strong style={{ letterSpacing: "0.5px" }}>{order.awbNumber}</strong> {order.awbNumber ? <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.meeshoOrder.awbNumber, '', index, 'AWB No')} /> : ''}
                                  </Typography>
                                }


                                {type !== 'NON_BARCODED_RTO' ?
                                  type === 'RTO_RETURN' ?
                                    <Typography variant="body2" mb={0.3} sx={{
                                      fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                    }}>
                                      Packet id : <strong style={{ letterSpacing: "0.5px" }}>{order.meeshoOrder?.packetId || '-'} </strong>
                                      {order.meeshoOrder?.packetId ? <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.meeshoOrder.packetId, '', index, 'Packet ID')} /> : ''}
                                    </Typography>
                                    : <Typography variant="body2" mb={0.3} sx={{
                                      fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                    }}>
                                      Packet id : <strong style={{ letterSpacing: "0.5px" }}>{order.packetId} </strong><Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.packetId, '', index, 'Packet id')} />
                                    </Typography>
                                  : ''
                                }

                                <Typography variant="body2" mb={0.4} sx={{
                                  fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                }}>
                                  {/* Return Types: <strong style={{ letterSpacing: "0.5px" }}>{order.meeshoOrder && order.returnTypes}</strong> */}
                                  Return Types: <strong style={{ letterSpacing: "0.5px" }}>{order.returnTypes}</strong>
                                  {/* {order.meeshoOrder && order.awbNumber ? <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.meeshoOrder.awbNumber, '', index, 'AWB No')} /> : ''} */}
                                </Typography>
                                <Typography variant="body2" mb={0.3} sx={{
                                  fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                }}>
                                  Claim created date : <strong style={{ letterSpacing: "0.5px" }}>{formatDate(order.createdDate)}</strong>
                                </Typography>
                                {statusTab && statusTab === 'COMPLETED' &&
                                  <Typography variant="body2" mb={0.3} sx={{
                                    fontSize: { lg: "12px", xl: "13px" },
                                  }}>
                                    Claim submitted date : <strong style={{ letterSpacing: "0.5px" }}>{formatDate(order.updatedDate)}</strong>
                                  </Typography>
                                }
                                {statusTab && statusTab === 'CLAIM_NOT_SUBMITTED' &&
                                  <Typography variant="body2" mb={0.3} sx={{
                                    fontSize: { lg: "12px", xl: "13px" },
                                  }}>
                                    Claim Failed date : <strong style={{ letterSpacing: "0.5px" }}>{formatDate(order.updatedDate)}</strong>
                                  </Typography>
                                }

                              </Grid>
                              <Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
                                <Typography variant="body2" mb={0.4} sx={{
                                  fontSize: { lg: "12px", xl: "13px" }, // Responsive font sizes
                                }}>
                                  State of the packet : <span className='chip_chat_content' style={{ marginRight: "4px" }}> {order.stateOfPacket}</span>
                                  {/* <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.stateOfPacket, '', index, 'State of the packet')} /> */}
                                </Typography>
                                <Typography variant="body2" mb={0.3} sx={{
                                  fontSize: { lg: "12px", xl: "13px" },
                                }}>
                                  System AWB No : <strong style={{ letterSpacing: "0.5px" }}>{order.awbNumber}</strong>
                                  {order.awbNumber ? <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.awbNumber, '', index, 'AWB No')} /> : ''}
                                </Typography>
                                <Typography variant="body2" mb={0.3} sx={{
                                  fontSize: { lg: "12px", xl: "13px" },
                                }}>
                                  System Packetid : <strong style={{ letterSpacing: "0.5px" }}>{order.packetId}</strong>
                                  {order.packetId ? <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(order.packetId, '', index, 'Packet ID')} /> : ''}
                                </Typography>
                                {order.ticketId && <Typography variant="body2" mb={0.3} sx={{
                                  fontSize: { lg: "12px", xl: "13px" },
                                }}>
                                  Ticket ID : <strong style={{ letterSpacing: "0.5px" }}>{order.ticketId}</strong>
                                </Typography>}
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12} xl={5} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                {/* <div style={{ fontSize: "13px", marginBottom: "2px", maxHeight: "80px", overflow: 'auto' }}> */}
                                <Typography variant="body2" mb={0.3} sx={{
                                  fontSize: { lg: "12px", xl: "13px" }, maxHeight: "190px", overflow: 'auto'
                                }}>
                                  <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0', marginRight: '10px' }} onClick={() => copyToClipboard(order.description, '', index, 'Description')} /><strong >Description : </strong>
                                  {/* {order.description} */}
                                </Typography>
                                <Box sx={{ maxHeight: "45px", overflowY: "auto", border: "1px solid #d5d5d8;", padding: "2px 5px", borderRadius: "5px" }}><Typography variant="body2" sx={{
                                  fontSize: { lg: "12px", xl: "13px" }, maxHeight: "190px", overflow: 'auto'
                                }}>{order.description} </Typography></Box>
                                <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
                                  <Grid item sx={{ display: "flex" }}>
                                    <Typography variant="body2" style={{ alignItems: "center", display: "flex" }}>
                                      <TextField
                                        inputRef={(el) => (inputRefs.current[index] = el)}
                                        size="small"
                                        defaultValue={inputValuesRef.current[index] || ''} // Use ref for performance
                                        placeholder="Ticket Id"
                                        onChange={(e) => handleChange(index, e.target.value)}
                                        onBlur={() => handleBlur(index)}
                                        variant="outlined"
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            handleSubmitRequest(order, index)
                                          }
                                        }}
                                        sx={{ "& .MuiOutlinedInput-root": { height: "35px", fontSize: "12px" } }}
                                      />
                                    </Typography>


                                  </Grid>
                                  <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', justifyContent: "end", alignItems: "center" }}>
                                      <Button variant='contained' color='warning' style={{ marginRight: "10px", fontSize: '12px', padding: "10px 15px" }} onClick={() => { copyToAutofill(order, type, statusTab, downloadData, heading, 'Autofill') }}>
                                        Autofill
                                      </Button>
                                      {statusTab && (statusTab == 'CLAIM_NOT_SUBMITTED' || statusTab == 'PENDING') &&
                                        <Button variant='contained' disabled={!inputValuesRef.current[index]} style={{ marginRight: "10px", fontSize: '12px', padding: "10px 15px" }} onClick={() => !loaderIndexes[index] && handleSubmitRequest(order, index)}>
                                          {loaderIndexes[index] ? < Icon icon="svg-spinners:6-dots-scale" width="16" height="16" /> : "Submit"}
                                        </Button>
                                      }
                                      {statusTab && (statusTab === 'PENDING' || statusTab === 'COMPLETED') &&
                                        <Button disabled={generatedTickets && generatedTickets[index]} variant='contained' color='error' style={{ padding: "10px 15px", fontSize: '12px' }} onClick={() => !loaderIndexes[index] && handleFailRequest(order, index)}>{loaderIndexes[index] ? < Icon icon="svg-spinners:6-dots-scale" width="16" height="16" /> : "Failed"}</Button>
                                      }
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>
                        </>
                      }
                    </Box>
                  )
                }
              })}
            </Grid>
            {totalPage > 1 && showPagination ? <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Pagination page={page} count={totalPage} shape='rounded' color='primary' onChange={handlePageChange} />
              <Box display="flex" justifyContent="flex-end" mb={2} alignItems='center'>
                <label>
                  <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                  Select All
                </label>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleBulkFail()}
                  style={{ marginLeft: "10px" }}
                >
                  All Failed
                </Button>
              </Box>
            </Box>
              : <Box display="flex" justifyContent="flex-end" mb={2} alignItems='center'>
                <label>
                  <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                  Select All
                </label>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleBulkFail()}
                  style={{ marginLeft: "10px" }}
                >
                  All Failed
                </Button>
              </Box>}
          </Box>
        </Box >
      </>
    )
  }
  // const renderedChats = useMemo(() => renderChats(), [data,inputValuesRef.current]);

  return (
    <Box sx={{ height: 'calc(100% - 5rem)', overflowY: 'auto', overflowX: 'hidden', padding: "10px 10px 0" }}>
      <>{renderChats()}</>
      {/* {renderedChats} */}
    </Box>
  )
}

export default ChatLog
